import { render, staticRenderFns } from "./KeywordContent.vue?vue&type=template&id=4138b8d3"
import script from "./KeywordContent.vue?vue&type=script&lang=js"
export * from "./KeywordContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports